export default (v, simbolo) => {
    if (!v) {
        return 0;
    }
    let simbolos = {1: '$', 2: 'U$S'};
    let formato = new Intl.NumberFormat('es-AR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(v);
    return (simbolo) ? simbolos[parseInt(simbolo)] + ' ' + formato : formato;
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/moneda.js